import type { IllustrationMap } from '@/components/Illustration/types'
import { IdentityVerificationFailedIcon } from '@/components/Icons/IdentityVerificationFailedIcon'

export const elavonIllustrations: Partial<IllustrationMap> = {
  'identity-verification-failed': {
    component: IdentityVerificationFailedIcon,
    fillColor: 'var(--icon-error-color)',
  },
}
